import { Pipe } from '@angular/core';
var MaxPipe = (function () {
    function MaxPipe() {
    }
    MaxPipe.prototype.transform = function (arr) {
        return Array.isArray(arr)
            ? Math.max.apply(Math, arr) : arr;
    };
    return MaxPipe;
}());
export { MaxPipe };
MaxPipe.decorators = [
    { type: Pipe, args: [{ name: 'max' },] },
];
/** @nocollapse */
MaxPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=max.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/max.js
// module id = 239
// module chunks = 4